// The app's sections, in the order they appear in the sidebar and on the dashboard.
export type IconName =
  | "home" | "quote" | "pipeline" | "archive" | "production" | "stone"
  | "invoice" | "data" | "ring" | "inbox" | "clients" | "key" | "collection" | "chain" | "calendar" | "blog";

export interface Section {
  href: string;
  label: string;
  icon: IconName;
  blurb: string; // one line under the tile on the dashboard
  badge?: "inquiries" | "production" | "invoices" | "proposals" | "memo";
}

export const SECTIONS: Section[] = [
  { href: "/clients", label: "Client Profiles", icon: "clients", blurb: "Everyone, with their quotes and files" },
  { href: "/pipeline", label: "Pipeline", icon: "pipeline", blurb: "Every client in progress" },
  { href: "/quotes", label: "Quote Builder", icon: "quote", blurb: "Price a piece for a client" },
  { href: "/production", label: "Production Pieces", icon: "production", blurb: "What's where, and when it's due", badge: "production" },
  { href: "/inquiries", label: "Inquiries", icon: "inbox", blurb: "New inquiries and Shopify orders", badge: "inquiries" },
  { href: "/collection", label: "Collection", icon: "collection", blurb: "Made-to-order pieces and their pricing" },
  { href: "/chains", label: "Chain Builder", icon: "chain", blurb: "Price chains, findings and labor" },
  { href: "/stones", label: "Stone Inventory", icon: "stone", blurb: "Viewed, on memo, owned, for sale", badge: "memo" },
  { href: "/invoices", label: "Invoices", icon: "invoice", blurb: "Bills to pay", badge: "invoices" },
  { href: "/data", label: "Data", icon: "data", blurb: "Numbers and usual costs" },
  { href: "/files", label: "Saved Files", icon: "archive", blurb: "CADs, photos and files, by client" },
  { href: "/proposals", label: "Awaiting Proposals", icon: "ring", blurb: "Finished, not yet given", badge: "proposals" },
];

// Side projects: tucked at the bottom of the sidebar, and below a line on the dashboard.
export const EXTRA_SECTIONS: Section[] = [
  { href: "/content", label: "Content Planner", icon: "calendar", blurb: "Social posts by date, plus an idea bank" },
  { href: "/blog", label: "Blog Posts", icon: "blog", blurb: "Plan, draft and track posts for the website" },
];

export const SETTINGS_SECTIONS: Section[] = [
  { href: "/pricing-key", label: "Pricing Key", icon: "key", blurb: "Rates, metal, casting, defaults" },
];
